import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/news";
import { formatViews } from "@/lib/news";

export default function RelatedNews({ items }: { items: NewsItem[] }) {
  if (items.length === 0) return null;

  return (
    <section className="mt-10 border-t border-background-200 pt-8">
      <div className="mb-5 flex items-center gap-2">
        <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
        <h2 className="font-heading text-xl font-bold text-foreground-900">相关内容推荐</h2>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((news) => (
          <Link
            key={news.id}
            to={`/detail/${news.id}`}
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <div className="h-32 w-full overflow-hidden bg-background-200">
              <img
                src={news.cover}
                alt={`${news.title} - 91爆料相关推荐`}
                title={`${news.title} - 91爆料`}
                className="h-32 w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-3">
              <h3 className="line-clamp-2 text-sm font-semibold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {news.title}
              </h3>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
                <span>{news.category}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatViews(news.views)}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}